import Big from 'big.js';
import * as graphql from 'generated/graphql';
import _ from 'lodash';
import { ITypeSpecificPolicy } from 'modules/common/layer01/apolloClient/cache/typePolicies/shared';



export const MessageDataValue: ITypeSpecificPolicy<graphql.MessageDataValue> = {

  fields: {

    formattedValue: {
      read: (existing, { readField }) => {
        const unitFieldReadResult = readField<graphql.DataPointUnit>('unit');
        const valueFieldReadResult = readField<string>('value');

        if (_.isNil(unitFieldReadResult) || _.isNil(valueFieldReadResult)) {
          return valueFieldReadResult;
        }

        const valueAsNumber = _.toNumber(valueFieldReadResult);
        // Other things that are not numbers can be put in here.
        if (_.isNaN(valueAsNumber)) {
          return valueFieldReadResult;
        }

        switch (unitFieldReadResult) {
          case 'float':
            return valueAsNumber.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
              useGrouping: true
            });

          case 'usdpershare':
          case 'usd':
            const val = Big(valueAsNumber);
            if (val.abs().gte(1_000_000)) {
              return val.div(1_000_000).toNumber()
                .toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                  useGrouping: true,
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }) + 'M';
            }

            return valueAsNumber.toLocaleString('en-US', {
              currency: 'USD',
              useGrouping: true,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });

          case 'percentage':
            return (valueAsNumber * 100).toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
              useGrouping: true
            }) + '%';

          case 'multiple':
            return valueAsNumber.toLocaleString('en-US', {
              useGrouping: true,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
          default:
            return valueAsNumber.toLocaleString('en-US', {
              useGrouping: true,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }) + ' ' + unitFieldReadResult;
        }
      }
    }
  }

};
